import { request } from '@/utils/request'

const prefix = '/app'

export function getUpdatesSettings (lastUpdateDate) {
  return request({
    url: `${prefix}/updates/settings?` + ((lastUpdateDate && `lastUpdateDate=${lastUpdateDate}`) || ''),
    method: 'post'
  })
}

export function getSettings () {
  return request({
    url: `/rest/db-settings`,
    method: 'get'
  })
}

/**
 * Update list with settings
 *
 * @param settings is json array [{name, value, description}...]
 * @returns { promise }
 */
export function updateSettings (settings) {
  return request({
    url: `/rest/db-settings/update`,
    method: 'post',
    data: settings
  })
}



// WEBPACK FOOTER //
// ./src/rest/settings.js